import * as ScrollMagic from "scrollmagic";
import { ScrollMagicPluginIndicator} from "scrollmagic-plugins";
import $ from 'jquery';

ScrollMagicPluginIndicator(ScrollMagic);

const triggers = [...document.querySelectorAll('.trigger-mid')];

if (triggers.length > 0) {
    triggers.forEach(function (trigger) {
      
        // init controller
        var controller = new ScrollMagic.Controller();
        // build scene
        var scene = new ScrollMagic
            .Scene({
                triggerElement: trigger,
                 duration: 800,
                 offset: -90
                 })
            .addTo(controller)
            //.addIndicators() 
            .on("progress", function (e) {
                var container = e.currentTarget.triggerElement();
                var target = container.querySelector('.backgroundTitle');
                if(target){

                var translateX = -200;
                translateX = translateX + ((e.progress.toFixed(3) * 600));
                let zmienna = (e.progress.toFixed(3));
           
                if(translateX < 960){
                    target.style.transform = "translateX("+ (-translateX) + "px)";
                    if(translateX > 950){
                        target.classList.add('hideTitle');
                    }else{
                        target.classList.remove('hideTitle');
                    }
                }
            }
             
            });
       
    });
}


const triggersTop = [...document.querySelectorAll('.trigger-top')];

if (triggersTop.length > 0) {
    triggersTop.forEach(function (trigger) {
      
        // init controller
        var controller = new ScrollMagic.Controller();
        // build scene
        var scene = new ScrollMagic
            .Scene({
                triggerElement: trigger,
                triggerHook: 0.2, // show, when scrolled 10% into view
                duration: "40%", // hide 10% before exiting view (80% + 10% from bottom)
                offset: 50 // move trigger to center of element
                 })
            .addTo(controller)
           
            .on("progress", function (e) {
                var container = e.currentTarget.triggerElement();
                var target = container.querySelector('.backgroundTitle');
                if(target){

                var translateX = -250;
                translateX = translateX + ((e.progress.toFixed(3) * 600));
           
                if(translateX < 960){
                    target.style.transform = "translateX("+ (-translateX) + "px)";
                    if(translateX > 950){
                        target.classList.add('hideTitle');
                    }else{
                        target.classList.remove('hideTitle');
                    }
                }
            }
             
            })
            //.addIndicators() ;
       
    });
}

const triggerEnd = [...document.querySelectorAll('.trigger-end')];

if (triggerEnd.length > 0) {
    triggerEnd.forEach(function (trigger) {
      
        // init controller
        var controller = new ScrollMagic.Controller();
        // build scene
        var scene = new ScrollMagic
            .Scene({
                triggerElement: trigger,
                triggerHook: 0.2, // show, when scrolled 10% into view
                duration: "40%", // hide 10% before exiting view (80% + 10% from bottom)
                offset: 50 // move trigger to center of element
                 })
            .addTo(controller)
           
            .on("progress", function (e) {
                var container = e.currentTarget.triggerElement();
                var target = container.querySelector('.bg-text-center-second');
                if(target){

                var translateX = -250;
                translateX = translateX + ((e.progress.toFixed(3) * 600));
           
                if(translateX < 960){
                    target.style.transform = "translateX("+ (-translateX) + "px)";
                    if(translateX > 950){
                        target.classList.add('hideTitle');
                    }else{
                        target.classList.remove('hideTitle');
                    }
                }
            }
             
            })
            //.addIndicators() ;
       
    });
}




if ($(window).width() > 992) {
    $('.image-sticky').addClass('img-sticky');
}
$(window).on('resize', function () {
    $('.image-sticky').toggleClass('img-sticky', $(window).width() > 992);
});



    var stickyImg = document.querySelector('.img-sticky');
    if(stickyImg){

   
    const image = [...document.querySelectorAll('.wp-block-motiblocks-column')];

    if (image.length > 0) {
        image.forEach(function (trigger) {
          
            // init controller
            var controller = new ScrollMagic.Controller();
            var container = document.querySelector('.wp-block-motiblocks-column');
            var height = container.clientHeight;
      
            var scene = new ScrollMagic
                .Scene({
                    
                     duration: height,
                
                     triggerElement: trigger,
                     triggerHook: 0.2, // show, when scrolled 10% into view
                     duration: "70%", // hide 10% before exiting view (80% + 10% from bottom)
                     offset: 50 // move trigger to center of element
                     })
                .addTo(controller)
                .on("progress", function (e) {
                    var container = e.currentTarget.triggerElement();
                    var target = container.querySelector('.img-sticky');
                    if(target){
    
                    var translateYStart = 0;
                    var translateY = 0;
                    translateY = translateY + ((e.progress.toFixed(3) * 550));

                  
                    if(translateY >= 615){
                        target.style.transform = "translateY("+ 615 + "px)";     
                    }else{
                        target.style.transform = "translateY("+ (translateYStart + translateY) + "px)";     
                    }
                    
                  
                    
                }
                 
                })
                //.addIndicators() ;;
           
        });
    }
}




const triggersTop2 = [...document.querySelectorAll('.trigger-top')];

if ($(window).width() > 992) {

    if (triggersTop2.length > 0) {
        triggersTop2.forEach(function (trigger) {
          
            // init controller
            var controller = new ScrollMagic.Controller();
            // build scene
            var scene = new ScrollMagic
                .Scene({
                    triggerElement: trigger,
                    triggerHook: 0.2, // show, when scrolled 10% into view
                    duration: "40%", // hide 10% before exiting view (80% + 10% from bottom)
                    offset: 50 // move trigger to center of element
                     })
                .addTo(controller)
               
                .on("progress", function (e) {
    
    
    
                    var container = e.currentTarget.triggerElement();
                    var target = container.querySelector('.bg-text-center');
                    if(target){
    
                    var translateX = -240;
                    translateX = translateX + ((e.progress.toFixed(3) * 600));
               
                    if(translateX < 960){
                        target.style.transform = "translateX("+ (-translateX) + "px)";
                        if(translateX > 950){
                            target.classList.add('hideTitle');
                        }else{
                            target.classList.remove('hideTitle');
                        }
                    }
                } 
    
                })
            //.addIndicators() ;
           
        });
    }
   
 }
 else {

    if (triggersTop2.length > 0) {
        triggersTop2.forEach(function (trigger) {
          
            // init controller
            var controller = new ScrollMagic.Controller();
            // build scene
            var scene = new ScrollMagic
                .Scene({
                    triggerElement: trigger,
                    triggerHook: 0.5, // show, when scrolled 10% into view
                    duration: "40%", // hide 10% before exiting view (80% + 10% from bottom)
                    offset: 90 // move trigger to center of element
                     })
                .addTo(controller)
               
                .on("progress", function (e) {
    
    
    
                    var container = e.currentTarget.triggerElement();
                    var target = container.querySelector('.bg-text-center');
                    if(target){
    
                    var translateX = -50;
                    translateX = translateX + ((e.progress.toFixed(3) * 600));
               
                    if(translateX < 960){
                        target.style.transform = "translateX("+ (-translateX) + "px)";
                        if(translateX > 950){
                            target.classList.add('hideTitle');
                        }else{
                            target.classList.remove('hideTitle');
                        }
                    }
                } 
    
                })
            //.addIndicators() ;
           
        });
    }
  
 }

